import useSWR from 'swr'
import { convertSelectedDates } from '../options/convertSelectedDates'
import { Row } from '../options/convertSelectedDates'
import fetchSelectedDates from '../options/fetchSelectedDates'

type Response = {
  isError: boolean
  isLoading: boolean
  selectedDates: Date[] | undefined
}

const useSelectedDates = (year: Date, factory_id: number, headers: any): Response => {
  const { data, error } = useSWR<Row[] | undefined>(['/api/selectedDates', year.getTime()], () =>
    fetchSelectedDates(year, factory_id, headers)
  )
  const selectedDates = convertSelectedDates(data || [])

  return {
    isError: !!error,
    isLoading: !error && !data,
    selectedDates: selectedDates,
  }
}

export default useSelectedDates
